import * as React from 'react';

export const TeamInfo = React.createContext({});
